import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { fluencyTrainingData, getDataForDifficulty } from './data/skills/speaking/fluencyTraining';

export default function FluencyTraining() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : fluencyTrainingData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
